var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenu1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 384,
    height: 384,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_1",
    d: "m368,154.66797l-352,0c-8.83203,0 -16,-7.16797 -16,-16s7.16797,-16 16,-16l352,0c8.83203,0 16,7.16797 16,16s-7.16797,16 -16,16zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_2",
    d: "m368,32l-352,0c-8.83203,0 -16,-7.16797 -16,-16s7.16797,-16 16,-16l352,0c8.83203,0 16,7.16797 16,16s-7.16797,16 -16,16zm0,0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    id: "svg_3",
    d: "m368,277.33203l-352,0c-8.83203,0 -16,-7.16797 -16,-16s7.16797,-16 16,-16l352,0c8.83203,0 16,7.16797 16,16s-7.16797,16 -16,16zm0,0"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu1);
export default __webpack_public_path__ + "static/media/menu1.ee3eb3ac56ac541bb54fadc71b7684de.svg";
export { ForwardRef as ReactComponent };